import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import React from 'react';
import PageControl from '../../../components/PageControl';
import PagingView from '../../../components/PagingView';
import '../styles/gallery.scss';
export default class Gallery extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            page: 0,
            pages: 0,
        };
    }
    render() {
        return (_jsxs("div", { className: classnames(this.props.className, 'gallery', { 'has-pages': this.state.pages > 1 }), children: [_jsxs("div", { className: "gallery__container", children: [_jsx("button", { rel: "prev", className: classnames({ 'is-disabled': this.state.page === 0 }), onClick: this._handlePrevClick.bind(this), onTouchStart: this._handlePrevClick.bind(this), children: _jsx("span", { children: _jsx("i", { className: "icon-arrow-left" }) }) }), _jsx("button", { rel: "next", className: classnames({ 'is-disabled': this.state.page === this.state.pages - 1 }), onClick: this._handleNextClick.bind(this), onTouchStart: this._handleNextClick.bind(this), children: _jsx("span", { children: _jsx("i", { className: "icon-arrow-right" }) }) }), _jsx(PagingView, { className: "gallery__content", page: this.state.page, onPagesChange: this._handlePagesChange.bind(this), children: (this.props.models || []).map(this._renderPhoto.bind(this)) })] }), this.state.pages > 1 ? (_jsx(PageControl, { className: "gallery__page-control", page: this.state.page, pages: this.state.pages, onPageClick: this._handlePagesChange.bind(this) })) : null] }));
    }
    _renderPhoto(model, index) {
        return _jsx("div", { className: "gallery__photo", style: { backgroundImage: `url(${model.cover})` } }, `photo-${index}`);
    }
    _handlePagesChange(page, pages = this.state.pages) {
        this.setState({ page, pages });
    }
    _handlePrevClick(event) {
        event.preventDefault();
        this._updatePage(this.state.page - 1, this.state.pages);
    }
    _handleNextClick(event) {
        event.preventDefault();
        this._updatePage(this.state.page + 1, this.state.pages);
    }
    _updatePage(page, pages) {
        page = Math.max(0, Math.min(page, pages - 1));
        this.setState({ page, pages });
    }
}
